export const CONNECTION_ALL_TO_ALL = 'all-to-all';
